<template>
  <div>
    <!-- Primary Menu -->
    <transition name="fade">
      <div
        v-if="siteMenuFlyoutIsOpen"
        :class="{ 'pt-smh': $root.siteMessageIsVisible }"
        class="fixed inset-0 z-30"
      >
        <div class="h-full bg-paint pt-shh">
          <div class="h-full flex flex-col overflow-y-scroll scrolling-touch">
            <div class="px-ogs-large flex-1 flex flex-col">
              <ul class="flex-1 py-6 space-y-6">
                <li>
                  <a class="text-lg focus:outline-none" href="/colours"
                    >Colours</a
                  >
                </li>
                <li>
                  <button
                    class="text-lg focus:outline-none"
                    @click="openMenu(PAINTS_KEY)"
                  >
                    Shop Paints
                  </button>
                </li>
                <li>
                  <button
                    class="text-lg focus:outline-none"
                    @click="openMenu(OILS_KEY)"
                  >
                    Shop Oils
                  </button>
                </li>
                <li>
                  <a class="text-lg focus:outline-none" href="/contact"
                    >Contact</a
                  >
                </li>
                <li>
                  <button
                    class="text-lg focus:outline-none"
                    @click="openMenu(ABOUT_KEY)"
                  >
                    Why Natural?
                  </button>
                </li>
                <li>
                  <a class="text-lg focus:outline-none" href="/trade-paradise"
                    >Trade</a
                  >
                </li>
              </ul>
              <div class="space-x-6 flex justify-between pb-5">
                <div class="space-x-6">
                  <a href="/shop/customer/login">Login</a>
                  <a href="/gift-vouchers">Gift Vouchers</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Secondary Menus -->
    <transition name="fade">
      <SiteMenuFlyoutMega
        v-if="isOpenedMenu(PAINTS_KEY)"
        heading="Shop Paints"
        :menu-data="paintsMenuData"
        @close="closeMenu"
      />
    </transition>

    <transition name="fade">
      <SiteMenuFlyoutMega
        v-if="isOpenedMenu(OILS_KEY)"
        heading="Shop Oils"
        :menu-data="oilsMenuData"
        @close="closeMenu"
      />
    </transition>

    <transition name="fade">
      <SiteMenuFlyoutAbout
        v-if="isOpenedMenu(ABOUT_KEY)"
        :items="aboutMenuItems"
        @close="closeMenu"
      />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SiteMenuFlyoutMega from "./SiteMenuFlyoutMega.vue";
import SiteMenuFlyoutAbout from "./SiteMenuFlyoutAbout.vue";

export default {
  name: "SiteMenuFlyout",

  components: {
    SiteMenuFlyoutMega,
    SiteMenuFlyoutAbout,
  },

  props: {
    paintsMenuData: {
      type: Object,
      required: true,
    },
    oilsMenuData: {
      type: Object,
      required: true,
    },
    aboutMenuItems: {
      type: Array,
      required: true,
    },
    siteMeta: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      openedMenu: null,
    };
  },

  computed: {
    PAINTS_KEY: () => "paints",
    OILS_KEY: () => "oils",
    ABOUT_KEY: () => "about",
    ...mapState({
      siteMenuFlyoutIsOpen: (state) => state.ui.siteMenuFlyoutIsOpen,
    }),
  },

  mounted() {
    window.addEventListener("resize", this.handleResizeEvent);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResizeEvent);
  },

  methods: {
    openMenu(key) {
      this.openedMenu = key;
    },
    closeMenu() {
      this.openedMenu = null;
    },
    isOpenedMenu(key) {
      return key === this.openedMenu;
    },
    handleResizeEvent() {
      const windowWidth = window.innerWidth;
      if (windowWidth > 1024 && this.siteMenuFlyoutIsOpen) {
        this.$store.commit("closeSiteMenuFlyout");
      }
    },
  },
};
</script>
